<template>
  <div :class="{row: horizontal}">
    <label :class="customLabelClass">
      {{ inputLabel }}
      <i v-if="statusIcon !== ''" class="icon icon-transaction-detail"
        v-bind:class="statusIcon">
      </i>
    </label>
    <input class="form-control inputAccordionForm" type="number" disabled="true"
      v-if="inputType === 'number'"
      :class="customInputClass"
      :value="inputValue">
    </input>
    <input class="form-control inputAccordionForm" type="text" disabled="true"
      v-else
      :class="customInputClass"
      :value="inputValue">
    </input>
    <!-- Le slot par défaut pour afficher certains boutons comme le "View Transfer Order File" -->
    <slot></slot>
  </div>
</template>
<script>
/* @author TLV 24/06/2020
* @brief Component qui affiche les form-groups sur les détails d'une request (accès en lecture)
* @details Ce component a été créé pour permettre de modifier plus rapidement le visuel de ceux-ci si besoin
* @param inputLabel demande la valeur du label
* @param inputValue demande la valeur à afficher dans l'input
*/
export default {
  name: 'formReadGroupLabelInput',
  props: {
    colInputSize: {
      type: Number,
      default: 7
    },
    colLabelSize: {
      type: Number,
      default: 5
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    inputLabel: {
      type: String
    },
    inputValue: {
      type: String
    },
    statusIcon: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    }
  },
  data () {
    return {
      customErrorClass: '',
      customInputClass: '',
      customLabelClass: ''
    }
  },
  created () {
    if (this.horizontal) {
      this.customInputClass = 'col-' + this.colInputSize + ' p-0'
      this.customLabelClass = 'col-' + this.colLabelSize + ' p-0'
      this.customErrorClass = 'offset-' + this.colLabelSize + ' col-' + this.colInputSize + ' p-0'
    }
  }
}
</script>



// WEBPACK FOOTER //
// formReadGroupLabelInput.vue?8ee76104